import {ButtonSizeVariant} from "../../../basic-ui-components/button/base/button-props.interface";
import {IServiceFactory} from "../../../services/service-factory.interface";
import React from "react";
import {BlankHorizontalSeparatorBox} from "../../../basic-components/blank-separator/blank-horizontal-separator.box";

export function getButtonSizeVariant(services: IServiceFactory): ButtonSizeVariant {
    if(services.mediaQuery.lAndBelow) {
        return "xs";
    } else {
        return "m";
    }
}

export function getButtonsSeparator(services: IServiceFactory): React.ReactElement {
    return (<BlankHorizontalSeparatorBox multiplier={services.mediaQuery.lAndBelow ? 1 : 0.5}/>)
}